import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const GooglePlay = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='GooglePlay' {...props}>
    <g fill='none'><polygon stroke='#444' strokeLinejoin='round' strokeWidth='2' points='3 2 3 22 21 12' /><path stroke='#444' strokeWidth='2' d='M3,2 L14,16' /><path stroke='#444' strokeWidth='2' d='M3,8 L14,22' transform='matrix(1 0 0 -1 0 30)' /></g>
  </StyledIcon>
);
